"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _Pin = _interopRequireDefault(require("../../Icon/Icons/Pin"));
var _SidenavUtils = require("../SidenavUtils");
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    focusVisible: {
      border: "2px solid ".concat(theme.palette.common.white)
    },
    root: {
      '&:hover': {
        opacity: 1
      },
      color: theme.palette.common.white,
      opacity: 0.7
    }
  };
});
var defaultProps = {
  pin: false,
  pinType: ''
};
var _ref = /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null);
var _ref2 = /*#__PURE__*/_react["default"].createElement(_Pin["default"], null);
var Pin = function Pin(props) {
  var dataMetrics = props.dataMetrics,
    pin = props.pin,
    setPin = props.setPin,
    pinType = props.pinType;
  var classes = useStyles();
  var handleSetPin = function handleSetPin() {
    setPin(true);
    (0, _SidenavUtils.setPinnedLocalStorage)();
  };
  var handleSetHover = function handleSetHover() {
    setPin(false);
    (0, _SidenavUtils.removePinnedLocalStorage)();
  };
  if (pin) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.root,
      "data-metrics": dataMetrics
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      "aria-label": "unpin ".concat(pinType),
      color: "inherit",
      onClick: handleSetHover,
      tabIndex: 0,
      focusVisibleClassName: classes.focusVisible
    }, _ref));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    "data-metrics": dataMetrics
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    onClick: handleSetPin,
    focusVisibleClassName: classes.focusVisible,
    "aria-label": "pin ".concat(pinType)
  }, _ref2));
};
Pin.defaultProps = defaultProps;
Pin.propTypes = process.env.NODE_ENV !== "production" ? {
  dataMetrics: _propTypes["default"].string,
  /**
   * If `true`, the arrow icon is displayed, giving the opportunity to contract the sidenav and disable the pin
   * If `false` the pin icon is displayed, giving the opportunity to enable the pin
   */
  pin: _propTypes["default"].bool,
  /**
   * For screen readers this will add the aria label for pinned and unpinned if you would like a more detailed
   * label for what the pin is used for.
   */
  pinType: _propTypes["default"].string,
  /**
   * A callback function to the parent Drawer
   */
  setPin: _propTypes["default"].func.isRequired
} : {};
var _default = Pin;
exports["default"] = _default;